import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

/**
 * Get user document from users collection (Firebase root) by Firebase Auth UID.
 * User doc has: uid (clientId for clients), organizationId, type (client/coach/admin), authId,
 * firstName, lastName, displayName, email (for display).
 */
export async function getUserDataByAuth(authUid) {
  if (!authUid) return null;
  const ref = firebase
    .firestore()
    .collection("users")
    .where("authId", "==", authUid);
  const snapshot = await ref.get();
  if (snapshot.empty) return null;
  return snapshot.docs[0].data();
}
